import classes from '../index.module.scss';
import React, { useContext } from 'react';
import { SearchContext } from '../../../context/Search';
import { HashLink } from 'react-router-hash-link';
import { UserContext } from '../../../context/User';

const PurchaseOpportunitiesTableBody = () => {
  const { searchedData } = useContext(SearchContext);
  const { isLoggedIn } = useContext(UserContext);

  return (
    <>
      {
        searchedData.map(item => {
          const { posted_date, name, agency_name, id } = item;

          return (
            <tr key={id}>
              <td className={`${classes.No_Wrap} ${classes.Title_Normal}`}>{posted_date}</td>
              <td>
                <p className={classes.Title_Bold}>
                  <HashLink
                    to={isLoggedIn ? `/purchase?id=${id}` : '/#basic-info'}
                    smooth
                  >
                    {name}
                  </HashLink>
                </p>
              </td>
              <td  className={`${classes.No_Wrap} ${classes.Title_Normal}`}>Federal Contract</td>
              <td className={classes.Title_Normal}>{agency_name || "-"}</td>
            </tr>
          )
        })
      }
    </>
  )
}

export default PurchaseOpportunitiesTableBody;